/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userBusinessProfile.internal

import features.userBusinessProfile.models.UserBusinessProfileModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest
import kangaroorewards.appsdk.core.network.base.PathParameter
import kangaroorewards.appsdk.core.network.base.replaceInPath

internal class UserBusinessProfileRequest : NetworkRequest() {

    suspend fun getUserBusinessProfile(
        overrideHeaders: Map<String, String>? = null,
        businessId: String
    ): IOResult<UserBusinessProfileModel> {
        return safeNetworkCall {
            get(
                endpoint = UserBusinessProfileEndpoint.replaceInPath(
                    PathParameter("businessId", businessId),
                ),
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
